import React, { useState } from 'react';
import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import Flex from '@atlaskit/primitives/components/flex';
import Text from '@atlaskit/primitives/text';
import { xcss } from '@atlaskit/primitives/xcss';
import IconButton from '@atlaskit/button/icon/button';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { i18n } from './inlineCommentsi18n.ts';

const expandedContentStyles = xcss({
	marginTop: 'space.150',
});

interface DanglingContentProps {
	annotatedText?: string | null;
}

export const DanglingContent: React.FC<DanglingContentProps> = ({ annotatedText }) => {
	const { formatMessage } = useIntl();
	const [isDanglingContentExpanded, setIsDanglingContentExpanded] = useState(false);

	return (
		<Box>
			<Flex gap="space.100" alignItems="center" justifyContent="space-between">
				<Flex gap="space.100" alignItems="center">
					<Text size="small" maxLines={3} color="color.text" weight="bold">
						{formatMessage(i18n.thisContentWasDeleted)}
					</Text>
				</Flex>
				<Tooltip
					content={
						isDanglingContentExpanded
							? formatMessage(i18n.collapseDeletedContent)
							: formatMessage(i18n.viewDeletedContent)
					}
				>
					<IconButton
						appearance="subtle"
						icon={isDanglingContentExpanded ? ChevronUpIcon : ChevronDownIcon}
						label={
							isDanglingContentExpanded
								? formatMessage(i18n.collapseDeletedContent)
								: formatMessage(i18n.viewDeletedContent)
						}
						onClick={() => setIsDanglingContentExpanded(!isDanglingContentExpanded)}
						testId={
							isDanglingContentExpanded
								? 'dangling-content-toggle-collapse'
								: 'dangling-content-toggle-expand'
						}
						spacing="compact"
					/>
				</Tooltip>
			</Flex>
			{isDanglingContentExpanded && (
				<Box xcss={expandedContentStyles}>
					<Text size="small" color="color.text.subtlest" maxLines={3}>
						{annotatedText}
					</Text>
				</Box>
			)}
		</Box>
	);
};
